import { render } from "./BlueBox.vue?vue&type=template&id=29bbef9a&scoped=true"
import script from "./BlueBox.vue?vue&type=script&lang=js"
export * from "./BlueBox.vue?vue&type=script&lang=js"

import "./BlueBox.vue?vue&type=style&index=0&id=29bbef9a&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bbef9a"]])

export default __exports__